import Model from "./Model";

export default class PolygonPopulation extends Model {
  static type = "polygonPopulations";

  population!: number;
  equivalentPopulation!: number;
  families!: number;
  commercialDensity!: number;
  towns!: number;
  districts!: number;
  regions!: number;
  town!: string;
  district!: string;
  region!: string;
  cap!: string;
  ratio!: string;
}
